import { getLocalStorageItemAsString, setLocalStorageItem } from '@atlassian/search-common';

const SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';

export const addVisitedLink = (value: string): void => {
	setLocalStorageItem(SEARCH_PAGE_VISITED_KEY, JSON.stringify([...getVisitedLinks(), value]));
};

export const getVisitedLinks = (): Set<string> => {
	const visitedLinksRaw = getLocalStorageItemAsString(SEARCH_PAGE_VISITED_KEY);
	return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};

export const isVisited = (visitedLinks: Set<string>, id: string): boolean => {
	return visitedLinks.has(id);
};
